import { getVerificationStatus } from "../api/profileApi";
import { getStoredUserEmail } from "./sessionContext";
import { CONTACT_VERIFICATION_ROLE, getContactVerificationPromptMessageFromStatus, getContactVerificationState, shouldShowContactVerificationPrompt, syncContactVerificationFromProfile } from "./contactVerification";

const API_ROLE_BY_VERIFICATION_ROLE = {
  [CONTACT_VERIFICATION_ROLE.FAMILY]: "FAMILYMEMBER",
  [CONTACT_VERIFICATION_ROLE.CAREGIVER]: "CAREGIVER",
};

export const resolveHomeVerificationPrompt = async (role) => {
  const normalizedRole = role === CONTACT_VERIFICATION_ROLE.CAREGIVER ? CONTACT_VERIFICATION_ROLE.CAREGIVER : CONTACT_VERIFICATION_ROLE.FAMILY;
  const emailId = getStoredUserEmail();

  if (!emailId) {
    return { shouldShow: false, message: "" };
  }

  if (!shouldShowContactVerificationPrompt(normalizedRole)) {
    return { shouldShow: false, message: "" };
  }

  const result = await getVerificationStatus({
    emailId,
    role: API_ROLE_BY_VERIFICATION_ROLE[normalizedRole],
  });

  if (result.success && result.data) {
    syncContactVerificationFromProfile(normalizedRole, {
      emailVerified: result.data.isEmailVerified,
      mobileVerified: result.data.isMobileVerified,
    });
  }

  if (!shouldShowContactVerificationPrompt(normalizedRole)) {
    return { shouldShow: false, message: "" };
  }

  const { emailVerified, mobileVerified } = getContactVerificationState(normalizedRole);
  return {
    shouldShow: true,
    message: getContactVerificationPromptMessageFromStatus(emailVerified, mobileVerified),
  };
};
